export default "__VITE_ASSET__xK_R_VEf__"